import ServiceCategoryPage from "../components/ServiceCategoryPage";
import tileWorkerService from "../data/services/tileWorkerService";

function TileWorker() {
  return <ServiceCategoryPage service={tileWorkerService} />;
}

export default TileWorker;